import styled from '@emotion/styled'

const StyledTextarea = styled.textarea``

export default StyledTextarea
